import React, { FC, useState } from "react";
import { Block } from "kanopi-components/Block";
import { Button, TButtonProps } from "kanopi-components/Button";
import { mergeOverrides } from "baseui";
import { Modal } from "kanopi-components/Modal";
import { ParagraphSmall } from "kanopi-components/typography";
import { useStyletron } from "baseui";

type TAdminMarkPaidQuoteModal = {
  quote: TQuote;
  markPaid: () => void;
  openModal: (arg: boolean) => void;
};

export const AdminMarkPaidQuoteModal: FC<TAdminMarkPaidQuoteModal> = ({
  markPaid,
  openModal,
}) => {
  const [, theme] = useStyletron();

  const handleSubmit = async () => {
    markPaid();
  };

  return (
    <Modal onClose={() => openModal(false)} closeable isOpen={true} animate autoFocus>
      <Modal.Header $style={{ textAlign: "center" }}>Mark quote as paid</Modal.Header>
      <Modal.Body $style={{ marginTop: theme.sizing.scale800 }}>
        <Block width="100%">
          <ParagraphSmall>
            Are you sure you want to mark quote as paid? You will not be able to revert
            this.
          </ParagraphSmall>
        </Block>
      </Modal.Body>
      <Modal.Footer>
        <Button kind={Button.KIND.primary} onClick={handleSubmit}>
          Confirm
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

type TAdminMarkPaidQuoteButton = {
  quote: TQuote;
} & TButtonProps;

export const AdminMarkPaidQuoteButton: FC<TAdminMarkPaidQuoteButton> = ({
  quote,
  // color,
  overrides,
  ...props
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [isDisabled, setIsDisabled] = useState(false);
  const [btnText, setBtnText] = useState("Mark as paid");
  const [isLoading, setIsLoading] = useState(false);
  const [, theme] = useStyletron();
  const openModal = (open: boolean) => {
    setIsOpen(open);
  };

  const markPaid = () => {
    setIsOpen(false);
    setIsLoading(true);
    setTimeout(() => {
      setIsDisabled(true);
      setBtnText("Paid");
      setIsLoading(false);
    }, 2000);
  };

  return (
    <>
      <Button
        disabled={isDisabled}
        isLoading={isLoading}
        onClick={() => openModal(true)}
        outlined={true}
        overrides={mergeOverrides(
          {
            BaseButton: {
              style: {
                color: theme.colors.positive,
                outlineColor: theme.colors.positive,
                ":disabled": {
                  color: theme.colors.buttonDisabledText,
                  outlineColor: theme.colors.buttonDisabledText,
                },
              },
            },
          },
          overrides
        )}
        {...props}
      >
        {btnText}
      </Button>

      {isOpen && (
        <AdminMarkPaidQuoteModal
          quote={quote}
          markPaid={markPaid}
          openModal={openModal}
        />
      )}
    </>
  );
};
